<template>
  <v-select v-model="choice" :items="items" hide-details class="ma-0 pa-0" />
</template>

<script>
const choices = [
  {
    value: 'ACTIVE_ONLY',
    text: '有効のみ',
  },
  {
    value: 'ALL',
    text: 'すべて',
  },
]
export const StatusOptions = choices.reduce(
  (obj, choice) => ({
    [choice.value]: choice.value,
    ...obj,
  }),
  {},
)

export default {
  name: 'CampaignModalPageCreativeStatusSelect',
  props: {
    value: {
      type: String,
      validator(value) {
        return choices.map(choice => choice.value).includes(value)
      },
    },
  },
  computed: {
    items() {
      return choices
    },
    choice: {
      get() {
        return this.value
      },
      set(value) {
        return this.$emit('input', value)
      },
    },
    activeOnly: {
      get() {
        return this.value === StatusOptions.ACTIVE_ONLY
      },
      set(bool) {
        return this.$emit(
          'input',
          bool ? StatusOptions.ACTIVE_ONLY : StatusOptions.ALL,
        )
      },
    },
  },
}
</script>

<style></style>
